// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-drawer-index-module__panel-EVLjmk {
  background: #d3d3d3;
  width: 0;
  height: 100%;
  transition: width .3s;
  top: 0;
  overflow: hidden;
}

.\\------packages-components-bot-semi-src-components-ui-drawer-index-module__panel-EVLjmk.\\------packages-components-bot-semi-src-components-ui-drawer-index-module__open-jRFZ6M {
  width: 200px;
}

.\\------packages-components-bot-semi-src-components-ui-drawer-index-module__open-left-KX4AKI {
  left: 0;
}

.\\------packages-components-bot-semi-src-components-ui-drawer-index-module__open-right-lEUioq {
  right: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `------packages-components-bot-semi-src-components-ui-drawer-index-module__panel-EVLjmk`,
	"open": `------packages-components-bot-semi-src-components-ui-drawer-index-module__open-jRFZ6M`,
	"open-left": `------packages-components-bot-semi-src-components-ui-drawer-index-module__open-left-KX4AKI`,
	"openLeft": `------packages-components-bot-semi-src-components-ui-drawer-index-module__open-left-KX4AKI`,
	"open-right": `------packages-components-bot-semi-src-components-ui-drawer-index-module__open-right-lEUioq`,
	"openRight": `------packages-components-bot-semi-src-components-ui-drawer-index-module__open-right-lEUioq`
};
export default ___CSS_LOADER_EXPORT___;
